import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { RefundReasonsListResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const REFUND_REASONS_LIST_QUERY_KEY = 'refund_reasons_list';

// Option lists (e.g. the refund dialog) need every reason at once.
const REFUND_REASONS_PAGE_SIZE = 1000;

export const useRefundReasonsListQuery = (url: string) =>
  useQuery({
    queryKey: [REFUND_REASONS_LIST_QUERY_KEY, url],
    queryFn: () =>
      HttpClient.request<RefundReasonsListResponseData>({
        method: 'GET',
        url,
        params: { size_per_page: REFUND_REASONS_PAGE_SIZE },
      }),
    enabled: !!url,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
